<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div
      id="defaultId1"
      class="uedbd2"
      style="display: flex; height: 100%; background: #f5f5f5"
    >
      <div
        style="transition: 0.2s"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        v-loading="RiskLoding"
      >
        <div
          style="
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            padding-bottom: 11%;
          "
        >
          <div
            :class="!this.Compare ? '' : 'vague'"
            style="height: 98%; overflow: hidden"
          >
            <div class="left_menu margin-top30">
              <div class="FilterQuestion">
                <div class="left_menu_question">
                  <div class="table">
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        Transaction Year
                        <span class="Clear_all" @click="clearAllTags"
                          ><i
                            class="iconfont icon-qingchu"
                            style="color: #ff6a6a; margin-right: 5px"
                          ></i
                          >Clear All</span
                        >
                      </p>
                      <el-select
                        clearable
                        filterable
                        @change="ChangeAllList"
                        v-model="impYearDate"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        placeholder=" Transaction Year "
                      >
                        <el-option
                          v-for="item in impYearList"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">Country</p>

                      <el-select
                        filterable
                        v-model="countryCode"
                        clearable
                        @change="ChangeAllList"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        placeholder="Select Country"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in CountryList"
                          :key="item.countryCode"
                          :label="item.country"
                          :value="item.countryCode"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">Product Name</p>

                      <el-select
                        filterable
                        v-model="ProductName"
                        clearable
                        @change="ChangeAllList"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        placeholder="Select Product Name"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in ProductNameList"
                          :key="item.hsCode"
                          :label="item.hsDescription"
                          :value="item.hsCode"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.hsDescription"
                            placement="top"
                            :disabled="item.hsDescription.length < 70"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.hsDescription }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div style="height: 100%">
          <div
            class="list-label"
            v-show="!Compare"
            style="height: 100%"
            v-loading="RiskLoding"
          >
            <div
              id="c6d65e"
              class="trade_bottom_right_top Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  style="margin-right: 20px"
                  id="c0b733"
                  v-model="checked"
                  label
                  @change="changeSlctAll"
                  >All</el-checkbox
                >
              </div>
            </div>
            <div class="flex_center margin-bottom20">
              <ul class="flex_center Data-Management-ul">
                <li
                  v-for="(item, index) in managementMenu"
                  @click="MenuClick(item)"
                  :class="
                    menuActive == item.value
                      ? 'menuActiveColor font18 font_bold'
                      : 'font18'
                  "
                  :key="index"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
            <h3 class="operations-head-content">
              <span
                class="operations-head font1A2332 font_bold"
                v-if="menuActive == 2"
                >List of Origin Information</span
              >
              <span class="operations-head font1A2332 font_bold" v-else
                >List of Destination Information</span
              >
            </h3>
            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          class="conpany-center-list forbid item"
                          :class="{
                            iconbgActiveBG: NationalIndustryActive == index,
                          }"
                        >
                          <div
                            :class="
                              NationalIndustryActive == index
                                ? 'ListLeftActive'
                                : 'conpany-center-list-left'
                            "
                          >
                            <el-checkbox
                              v-if="isOpenSlct"
                              id="cee084"
                              style="margin-right: 10px; margin-top: 0.3rem"
                              v-model="item.isChecked"
                              label
                              @change="changeItemChecked"
                            >
                            </el-checkbox>
                            <span
                              :class="
                                item.isDing
                                  ? 'indexPositon'
                                  : 'indexPositonactive'
                              "
                              >{{ index + 1 }}</span
                            >
                            <div class="conpany-center-list-left-box">
                              <p style="align-items: center" class="flex_box">
                                <img class="contry_img" :src="item.flag" />
                                <span
                                  class="font_bold CountryActive"
                                  @click="setNews(item)"
                                  >{{ item.countryName }}</span
                                >
                                <span
                                  class="margin-left20"
                                  v-if="item.yearOnYearGrowthRate"
                                >
                                  <i
                                    v-if="item.yearOnYearGrowthRate < 0"
                                    class="iconfont icon-arrowup-copy"
                                    style="color: #009ea7"
                                  ></i>
                                  <i
                                    v-else
                                    class="iconfont icon-arrowup"
                                    style="color: #ff6a6a"
                                  ></i>
                                </span>
                                <span v-if="item.yearOnYearGrowthRate">
                                  <span
                                    v-if="item.yearOnYearGrowthRate < 0"
                                    style="color: #009ea7"
                                    >{{ item.yearOnYearGrowthRate }}%</span
                                  >
                                  <span v-else style="color: #ff6a6a"
                                    >+{{ item.yearOnYearGrowthRate }}%</span
                                  >
                                </span>
                              </p>
                              <p class="list-text-color">
                                <span>
                                  <span class="font666666"> ISO Code:</span>
                                  <span> {{ item.isoCode }}</span>
                                  <span class="fontDDDDDD margin-left20"
                                    >|</span
                                  >
                                  <span class="margin-left20 font666666">
                                    Currency:
                                  </span>
                                  <span>{{ item.currency }}</span>
                                </span>
                              </p>
                              <el-popover
                                :disabled="
                                  !NationalIndustryShow ||
                                  NationalIndustryActive != index
                                "
                                placement="top"
                                trigger="hover"
                                popper-class="table_popover"
                                :content="
                                  'Transaction Date:' +
                                  (item.latestTransactionDate == '' ||
                                  item.latestTransactionDate == null
                                    ? '-'
                                    : item.latestTransactionDate) +
                                  ' Total export amount:' +
                                  (item.totalExportAmount == '' ||
                                  item.totalExportAmount == null
                                    ? '-'
                                    : item.totalExportAmount) +
                                  ' Export frequency:' +
                                  (item.exportFrequency == '' ||
                                  item.exportFrequency == null
                                    ? '-'
                                    : item.exportFrequency)
                                "
                              >
                                <p slot="reference" class="list-text-color">
                                  <span class="showhis">
                                    <span class="font666666">
                                      Transaction Date:</span
                                    >
                                    <span>{{
                                      item.latestTransactionDate
                                    }}</span>
                                    <span class="fontDDDDDD margin-left10"
                                      >|</span
                                    >
                                    <span class="margin-left10 font666666">
                                      Total export amount:</span
                                    >
                                    <span>
                                      {{
                                        item.totalExportAmount | FilterNum
                                      }}</span
                                    >
                                    <span class="fontDDDDDD margin-left10"
                                      >|</span
                                    >
                                    <span class="margin-left10 font666666">
                                      Export frequency:</span
                                    >
                                    <span>
                                      {{
                                        item.exportFrequency | FilterNum
                                      }}</span
                                    >
                                  </span>
                                </p>
                              </el-popover>
                              <p
                                class="list-text-color pTop5"
                                style="align-items: flex-start"
                              >
                                <span
                                  class="font666666 txtTop5"
                                  v-if="menuActive == 1"
                                >
                                  Top 5 Export Products:
                                </span>
                                <span class="font666666 txtTop5" v-else>
                                  Top 5 Import Products:
                                </span>
                                <span
                                  ref="productsContainer"
                                  :class="{
                                    MainProductsMainProducts:
                                      item.MainProductsShow &&
                                      (!item.showMore || NationalIndustryShow),
                                  }"
                                >
                                  <el-popover
                                    v-for="(
                                      ite, index
                                    ) in item.topFiveExportProducts"
                                    placement="top"
                                    trigger="hover"
                                    popper-class="table_popover"
                                    :content="ite"
                                  >
                                    <span
                                      class="MainProducts margin-right10 font16"
                                      slot="reference"
                                      :key="index"
                                      >{{ ite }}
                                    </span>
                                  </el-popover>
                                </span>
                                <span
                                  class="MainProductsAll"
                                  v-if="
                                    item?.topFiveExportProducts?.length > 1 &&
                                    !item.showMore &&
                                    !NationalIndustryShow
                                  "
                                  @click="
                                    item.MainProductsShow =
                                      !item.MainProductsShow
                                  "
                                  >...</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="conpany-center-list-right">
                            <p>
                              <el-popover
                                placement="top"
                                trigger="hover"
                                popper-class="table_popover"
                                content="Shipping Overview"
                              >
                                <button
                                  slot="reference"
                                  class="margin-left20 iconbg flex_center"
                                >
                                  <i
                                    @click="exportCompanyImport(item)"
                                    class="iconfont icon-yunshu"
                                    style="color: #009ea7"
                                  ></i>
                                </button>
                              </el-popover>

                              <el-popover
                                placement="top"
                                trigger="hover"
                                popper-class="table_popover"
                                content="Trade History and Trends"
                              >
                                <span
                                  slot="reference"
                                  class="margin-left20 iconbg flex_center"
                                  :class="{
                                    iconbgActive:
                                      NationalIndustryActive == index,
                                  }"
                                >
                                  <i
                                    v-if="NationalIndustryActive == index"
                                    @click="NationalIndustry(item, index)"
                                    class="iconfont icon-qushi"
                                    style="color: #ffffff"
                                  ></i>
                                  <i
                                    v-else
                                    @click="NationalIndustry(item, index)"
                                    class="iconfont icon-qushi"
                                    style="color: #009ea7"
                                  ></i>
                                </span>
                              </el-popover>
                            </p>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    Show All
                  </div>
                </div>
              </div>
              <div
                class="risk-right"
                v-if="NationalIndustryShow"
                :style="{ marginTop: calculateMarginTop() + 'px' }"
              >
                <div class="flex_center_between_box margin-bottom20">
                  <p style="font-family: Arial Bold; margin-bottom: 0px">
                    Trade History and Trends
                  </p>
                  <div class="flex_center">
                    <i
                      class="iconfont icon-cuowu"
                      @click="rifghtUpdate()"
                      style="color: #1a2332"
                    ></i>
                  </div>
                </div>
                <el-date-picker
                  v-model="datePicker"
                  class="trade_date_picker"
                  @change="getgetTradeTrends()"
                  type="monthrange"
                  range-separator=""
                  start-placeholder="Start date"
                  value-format="yyyy-MM"
                  end-placeholder="End date"
                ></el-date-picker>
                <div class="margin-top30">
                  <div
                    ref="SupplyChainEchart"
                    style="width: 100%; height: 486px; padding-bottom: 5px"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <SupplyChainList
      :ContactObj="ContactInfo"
      :suoClose="SupplyChain"
      @clossuoDialogtwo="clossuoDialogtwo($event)"
    ></SupplyChainList>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";

import SupplyChainList from "../../TradeProduct/SupplyChainList.vue";

import Login from "@/components/login.vue";

import {
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
  getOriginOrDestinationList,
  getOriginOrDestinationListFilter,
  getTradeTrends,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  watch: {},

  mixins: [mixins1],
  components: {
    draggable,
    Login,
    SupplyChainList,
  },

  data() {
    return {
      PCMoudele: [],
      LastUpdate: "",
      SupplyChain: false,
      ContactIn: false,
      datePicker: ["2025-01", "2025-12"],
      loginDialog: false,
      Compare: false,
      ContactInfo: {
        aaa_id: "",
        web_site: "",
        company_country: "",
      },
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: "",
      buyerNameList: [],
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,
      MainProductsShow: "",

      menuActive: 2,
      importGrowthRateTrendList: [],
      importTrendListEcharts: [],
      managementMenu: [
        {
          label: "Origin",
          value: "2",
        },
        {
          label: "Destination",
          value: "1",
        },
      ],

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],
      parentTable: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,
      ProductName: "",
      ProductNameList: [],
      HSCode: "",
      CountryList: "",
      countryCode: "",
      impYearList: [],
      impYearDate: "",
      HSCodeList: [],
    };
  },
  methods: {
    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    clearAllTags() {
      this.impYearDate = "";
      this.ProductName = "";
      this.countryCode = "";
      this.datePickerYear = "";
      this.ChangeAllList();
    },
    ChangeAllList() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";

      this.page.pageSize = 10;
      this.getSearchList();
      this.getOriginOrDestinationListFilterList();
    },
    MenuClick(item) {
      this.impYearDate = "";
      this.ProductName = "";
      this.countryCode = "";
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = null;
      this.page.pageSize = 10;
      this.menuActive = item.value;
      this.getSearchList();
      this.getOriginOrDestinationListFilterList();
    },

    // 获取列表数据
    getSearchList() {
      this.RiskLoding = true;
      getOriginOrDestinationList({
        hsCode: this.ProductName,
        transactionDate: this.impYearDate,
        countryCode: this.countryCode,

        type: this.menuActive,
        page: 1,
        pageSize: this.page.pageSize,
        aaaid: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.countryCode);
            if (countryImg) {
              let flag = require("../../../../../static" + countryImg);
              parentTable[index].flag = flag;
              parentTable[index].MainProductsShow = false;
              this.refresh++;
            }
          });
          this.CompanyList = parentTable;
          this.$nextTick(() => {
            this.CompanyList.forEach((item, index) => {
              const container = this.$refs.productsContainer?.[index];
              if (container.offsetHeight > 38) {
                item.MainProductsShow = true;
                item.showMore = false;
              } else {
                item.showMore = true;
              }
            });
          });
        } else {
          this.RiskLoding = false;
          this.CompanyList = [];
        }
      });
    },
    getOriginOrDestinationListFilterList() {
      getOriginOrDestinationListFilter({
        hsCode: this.ProductName,
        transactionDate: this.impYearDate,
        countryCode: this.countryCode,
        aaaid: this.$route.query.id3a,
        type: this.menuActive,
      }).then((res) => {
        if (res.code == 200) {
          this.impYearList = res.data.impYear;
          this.ProductNameList = res.data.productInfos;
          this.CountryList = res.data.countryInfos;
        }
      });
    },

    clossuoDialogtwo(value) {
      console.log(`value`, value);
      this.SupplyChain = value;
    },
    suppleEchart() {
      let that = this;

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "15%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          left: "0px",
          top: "0px",
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            rotate: -60, // 旋转角度设置为 45 度
          },
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },

            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString(); // 格式化为千分位
              },
            },
          },

          {
            type: "value",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString() + "%"; // 格式化为千分位
              },
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: "Trade Volume",
            type: "bar",
            barWidth: "20",
            itemStyle: { color: "#009EA7" },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " + value.toLocaleString();
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name: "Month on Month Ratio",
            type: "line",
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.growthRate),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },

    calculateMarginTop() {
      if (
        this.NationalIndustryActive === "null" ||
        this.NationalIndustryActive === null
      ) {
        return 0;
      }
      // 使用 Vue 的 refs 来获取元素（如果可能的话）
      const listContainer = document.querySelector(".risk-center-list ul");
      const listItems = document.querySelectorAll(".conpany-center-list");

      if (
        listItems.length > 0 &&
        this.NationalIndustryActive < listItems.length
      ) {
        const targetItem = listItems[this.NationalIndustryActive];

        if (targetItem && listContainer) {
          // 计算目标元素相对于列表容器的偏移量
          const containerRect = listContainer.getBoundingClientRect();
          const itemRect = targetItem.getBoundingClientRect();

          // 返回相对于容器顶部的偏移量
          return itemRect.top - containerRect.top;
        }
      }

      // 如果在 nextTick 之外执行，返回默认值
      // 实际的计算将在 nextTick 中完成
    },
    // 点击列表出现右侧数据
    NationalIndustry(item, index) {
      this.chageItTrue = true;
      this.NationalIndustryShow = true;
      this.NationalIndustryActive = index;
      this.aaaid = item.countryCode;
      this.datePicker = item.yearMonthList;
      this.$nextTick(() => {
        this.getgetTradeTrends();
        // 强制重新计算样式
        this.$forceUpdate();
        this.CompanyList.forEach((item, index) => {
          if (this.NationalIndustryActive == index) {
            item.MainProductsShow = true;
          }
        });
      });
    },
    getgetTradeTrends() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.menuActive == 1 ? 2 : 1,
        countryCodeFilter: this.aaaid,
        endMonth: this.datePicker[1],
        aaaid: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.$nextTick(() => {
            this.suppleEchart();
          });
        }
      });
    },
    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.CompanyList.forEach((item, index) => {
        if (item.index == this.NationalIndustryActive)
          item.MainProductsShow = false;
      });
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    // web导出
    exportCompanyWeb(item) {
      this.ContactIn = true;
      this.ContactInfo.aaa_id = item.aaa_id;

      this.ContactInfo.web_site = item.web_site;

      this.ContactInfo.company_country = item.company_country;
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },
    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        return getsearchExport({
          page: 1,
          pageSize: 100,
          export_aaaid: this.aaaId,
          import_aaaid: this.aaaId,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.rows.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.rows;
          } else {
            return [];
          }
        });
      }
    },
    exportCompanyImport(item) {
      this.SupplyChain = true;
      this.ContactInfo.aaa_id = item.aaaid;

      this.ContactInfo.web_site = item.website;

      this.ContactInfo.company_country = item.countryCode;
    },

    // 点击跳转
    setNews(row, detail) {
      this.$router.push({
        path: "Detail",
        query: {
          Moudles: this.$route.query.Moudles,
          idpower: this.$route.query.idpower,
          id3a: this.$route.query.id3a,
          SACode1: this.$route.query.SACode1,
          type: this.menuActive,
          countryCode: row.countryCode,
          currency: row.currency,
          isoCode: row.isoCode,
          exportFrequency: row.exportFrequency,
          latestTransactionDate: row.latestTransactionDate,
          sixMonthTransactions: row.sixMonthTransactions,
        },
      });
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 收藏

    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {},
  created() {
    this.setToolsfalse();
  },
  mounted() {
    //
    this.$emit("UpdatamarkTotalList", true);

    this.getSearchList();
    this.getOriginOrDestinationListFilterList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.trade_bottom_right_top {
  color: #999999;
  margin-bottom: 10px;
  font-size: 16px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.scrollbar {
  overflow: hidden;
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 665px;
  border-radius: 0 10px 10px 10px;
  z-index: 999;
  position: absolute;
  right: 15px;
}

.risk-center-list {
  width: 100%;
  position: relative;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
}

.risk-right-content-title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  display: flex;
  justify-content: space-between;
  padding: 30px 20px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow-x: hidden;
}
.conpany-center-list.iconbgActiveBG {
  border-radius: 10px;
}

.conpany-center-list-left {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 195px);
}
.ListLeftActive {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 525px);
}

.conpany-center-list-leftWith {
  width: calc(100% - 195px);
}
.conpany-center-list-left-box {
  width: calc(100% - 30px);
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  margin-right: 10px;
  color: #999999;
  width: 30px;
  font-family: "Arial Bold";
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
}

.showhis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contry_img {
  width: 36px;
  margin-right: 5px;
}

.iconbg {
  width: 50px;
  height: 50px;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}

.conpany-center-list-right {
  display: flex;
  align-items: center;
}

.conpany-center-list-right p {
  font-size: 24px;
  color: #1a2332;
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.bottom-list-echarts {
  padding-left: 2.8142857142857144rem;
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #f5f5f5;
  height: 18.571428571428573rem;
  /* flex: 1; */
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 10px;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 10px;
  padding-bottom: 20px;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color1290C9 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: Arial;
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 10px;
  border: 1px solid #ff7600;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  color: #1290c9;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 10px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}

.trade_date_picker,
.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
  font-size: 16px;
}
.trade_date_picker {
  width: 300px;
}
/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__label {
  font-size: 1.1428575rem;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}
.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
}
.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  max-width: 280px;
  height: 28px;
  background: #f5f5f5;
  border-radius: 10px;
  border: 1px solid #009ea7;
  padding: 4px 6px 6px 6px;
  margin-bottom: 5px;
  color: #009ea7;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MainProductsAll {
  min-width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}

.MainProductsMainProducts {
  height: 35px;
  overflow: hidden;
}

.iconbgActiveBG {
  background: #ddedee;
}

.iconbgActiveBG .iconbgActive {
  background: #009ea7;
}

.iconbgActiveBG {
  margin-right: 0px;
  border-radius: 10px 0px 0px 10px;
}
/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.icon-dianhuaheshi {
  font-size: 26px;
}
.icon-yunshu {
  font-size: 22px;
}
.icon-qushi {
  font-size: 28px;
}
.icon-arrowup-copy,
.icon-arrowup {
  font-size: 20px;
  margin-right: 10px;
}
.pTop5 {
  display: flex;
}
.pTop5Right {
  flex: 1;
}
.txtTop5 {
  min-width: 186px;
  height: 35px;
  line-height: 30px;
}
::v-deep .pTop5Right .el-popover__reference-wrapper {
  display: inline-block;
  width: 100%;
}
@media (max-width: 1920px) {
  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .left_menu_question {
    margin-bottom: 7px;
    padding-bottom: 15px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 225px;
  }
  .trade_bottom_right_top {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .conpany-center-list {
    padding: 22px 15px 15px;
    margin-bottom: 7px;
  }
  .flex_center_between_box p {
    font-size: 18px;
    min-height: 22px;
    margin-bottom: 7px;
  }
  .indexPositonactive {
    margin-right: 7px;
    width: 22px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }
  .conpany-center-list-leftWith {
    width: calc(100% - 108px);
  }
  .conpany-center-list-left-box {
    width: calc(100% - 22px);
  }
  .icon-dianhuaheshi {
    font-size: 24px;
  }
  .icon-yunshu {
    font-size: 20px;
  }
  .icon-qushi {
    font-size: 26px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 7px;
  }
  .contry_img {
    width: 28px;
    margin-right: 4px;
  }
  .list-text-color {
    font-size: 16px !important;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    width: 480px;
    padding: 15px;
    height: 685px;
  }
  .MainProducts {
    padding: 4px 5px 5px 5px;
  }
  .txtTop5 {
    min-width: 166px;
    height: 33px;
    line-height: 28px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
}
@media screen and (max-width: 1439px) {
  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .left_menu_question {
    margin-bottom: 6px;
    padding-bottom: 13px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .trade_bottom_right_top {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .conpany-center-list {
    padding: 20px 13px 13px;
    margin-bottom: 6px;
  }
  .flex_center_between_box p {
    font-size: 16px;
    min-height: 20px;
    margin-bottom: 6px;
  }
  .indexPositonactive {
    margin-right: 6px;
    width: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }

  .icon-dianhuaheshi {
    font-size: 20px;
  }
  .icon-yunshu {
    font-size: 18px;
  }
  .icon-qushi {
    font-size: 22px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 6px;
  }
  .contry_img {
    width: 24px;
    margin-right: 3px;
  }
  .list-text-color {
    font-size: 14px !important;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    width: 500px;
    padding: 13px;
    min-height: 42rem;
  }
  .MainProducts {
    padding: 4px 4px 4px 4px;
  }
  .txtTop5 {
    min-width: 146px;
    height: 33px;
    line-height: 28px;
  }
}
</style>
